<template>
  <LiveTradeDataTable></LiveTradeDataTable>
</template>

<script>
import LiveTradeDataTable from "./LiveTradeDataTable.vue";

export default {
  components: { LiveTradeDataTable },
}
</script>